export enum FondsAnlageKontext {
  INVESTITIONSBETRAG = 'INVESTITIONSBETRAG',
  ZUZAHLUNGSBETRAG = 'ZUZAHLUNGSBETRAG',
}
